import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, Validators, FormGroup, FormArray } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OverrideRule } from '../../../../shared/models/overrideRule';
import { OverrideRuleService } from '../../../../shared/services/overrideRule.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AgeRange } from '../../../models/ageRange';
import { AgeRangeService } from '../../../services/ageRange.service';
import { StoreLocationService } from '../../../services/storelocation.service';
import { StoreLocation } from '../../../models/storeLocation';
import { CampaignType } from '../../../models/CampaignType';
import { CampaignTypeService } from '../../../services/campaignType.service';
import { ValidationService } from '../../../services/validation.service';
import { DatePipe } from '@angular/common'

@Component({
  selector: 'app-override-rule-edit-form',
  templateUrl: './override-rule-edit.component.html'
})

export class OverrideRuleEditFormComponent implements OnInit { 

  //input/output parameters
  @Input() title;
  @Input() overrideRule: OverrideRule; 
  //@Output() eventEmitter: EventEmitter<any> = new EventEmitter();

  editForm: FormGroup; 
  submitted = false; 
  public ageRangeList: AgeRange[];  
  public genderList = ['F', 'M'];
  public storeLocationList: StoreLocation[];
  public campaignTypeList: CampaignType[];
  public fields: FormArray;
  public fieldNames: string[] = ['FrontImage', 'FrontCTA', 'FrontOffer', 'FrontLogo', 'BackLogo', 'BackCTA', 'BackBackground', 'BackBottomLeftCopy', 'BackOfferBlock', 'BackStoreBlock', 'Style', 'Custom1', 'Custom2', 'Custom3', 'Custom4', 'Custom5', 'StoreDescription'];
  public startDate: Date;
  public endDate: Date;

  constructor(
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private overrideRuleService: OverrideRuleService,
    private ageRangeService: AgeRangeService,
    private storeLocationService: StoreLocationService,
    private notification: MatSnackBar,
    public datepipe: DatePipe,
    private campaignTypeService: CampaignTypeService) { }

  // on component load
  ngOnInit() {
    // bind campaign types
    this.campaignTypeService.getAll().subscribe(campaignResult => {
      this.campaignTypeList = campaignResult;
    });
     
    // bind age ranges dropdown
    this.ageRangeService.getAll().subscribe(result => {
      this.ageRangeList = result;
    });

    // bind store locations dropdown
    this.storeLocationService.getAll(this.overrideRule.brandId).subscribe(result => {
      this.storeLocationList = result;
    });

    // create a form group for each item in the fields array model
    const formGroups = this.overrideRule.fields.map(x => this.formBuilder.group({
      name: [x.name, Validators.required],
      value: [x.value, Validators.required]
    }));

    // init dates
    this.startDate = new Date(this.overrideRule.startDate);
    this.endDate = new Date(this.overrideRule.endDate);

    // build form
    this.editForm = this.formBuilder.group({ 
      gender: [(this.overrideRule.gender === null || this.overrideRule.gender === '') ? null : this.overrideRule.gender],
      months: [this.overrideRule.months, ValidationService.numericValidator],
      brandId: [this.overrideRule.brandId || 0],
      campaignTypeId: [this.overrideRule.campaignTypeId || 0],
      storeLocationId: [this.overrideRule.storeLocationId || 0],
      ageRangeId: [this.overrideRule.ageRangeId || 0, [Validators.required, Validators.min(1)]],
      priority: [this.overrideRule.priority, [Validators.required, Validators.min(0)]],
      startDate: ['', Validators.required],//[this.datepipe.transform(this.overrideRule.startDate, 'MM/dd/yyyy') || '' || '', Validators.required],
      endDate: ['', Validators.required], //new Date(this.overrideRule.endDate),
      //[this.datepipe.transform(this.overrideRule.endDate, 'MM/dd/yyyy') || '', Validators.required],
      custom1: this.overrideRule.custom1 || '',
      custom2: this.overrideRule.custom2 || '',
      custom3: this.overrideRule.custom3 || '',
      custom4: this.overrideRule.custom4 || '',
      custom5: this.overrideRule.custom5 || '',
      fields: this.formBuilder.array(formGroups)
    });
  }

  createItem(): FormGroup {
    return this.formBuilder.group({
      name: ['', Validators.required],
      value: ['', Validators.required]
    });
  }

  // remove field
  removeFieldName(i: number): void {
    const fa = this.editForm.get('fields') as FormArray;
    fa.removeAt(i);
  }

  // add field
  addFieldName(): void {
   const fa = this.editForm.get('fields') as FormArray;
    fa.push(this.createItem());
  }

  // handle form submit 
  onSubmit() {
      this.submitted = true;
      
      // stop here if form is invalid
      if (this.editForm.invalid) {
        return; 
      } 
      const model = this.editForm.value as OverrideRule;
      model.brandId = +this.editForm.value['brandId'];
      model.campaignTypeId = +this.editForm.value['campaignTypeId'];
      model.storeLocationId = +this.editForm.value['storeLocationId'];
      model.ageRangeId = +this.editForm.value['ageRangeId'];
      model.months = +this.editForm.value['months'];
      model.priority = +this.editForm.value['priority'];

      this.overrideRuleService.update(+this.overrideRule.id, model).subscribe(overrideRule => {       
        //this.eventEmitter.emit(this.editForm.value);
        this.activeModal.close(true);
        this.showNotification(`The entry was successuly updated!`, 'Okay!') 
      }); 
  }

  decline(): void {
    this.activeModal.close(false);
  }

  dismiss(): void {
    this.activeModal.dismiss();
  }

  // display notifications
  showNotification(msg: string, action: string) {
    this.notification.open(msg, action, { duration: 5000, panelClass: ['snackbar-success'] });
  }

  // format date
  formatDate(e, fieldName: string) {
    if (e.target.value === null) {
      this.editForm.get(fieldName).setValue('', {
        onlyself: true
      })
    }
    else {
      console.log(e.target);
      var convertDate = new Date(e.target.value);

      this.editForm.get(fieldName).setValue(convertDate, {
        onlyself: true
      })
    }
  }
}
